'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Birthdate = function (_PureComponent) {
	_inherits(Birthdate, _PureComponent);

	function Birthdate() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Birthdate);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Birthdate.__proto__ || Object.getPrototypeOf(Birthdate)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hasBeenFocused: false, focus: false }, _this.onFocus = function () {
			if (!_this.state.hasBeenFocused) _this.setState({ hasBeenFocused: true });
			_this.setState({ focus: true });
		}, _this.onBlur = function () {
			_this.setState({ focus: false });
		}, _this.onChange = function (select) {
			return function (_ref2) {
				var valueS = _ref2.value;
				var _this$props = _this.props,
				    onChange = _this$props.onChange,
				    value = _this$props.value;


				var split = value.split('-');
				var year = split[0];
				var month = split.length > 1 ? split[1] : "";
				var day = split.length > 2 ? split[2] : "";

				switch (select) {
					case 'year':
						year = valueS;
						day = "";
						if (valueS === "") month = "";
						break;
					case 'month':
						month = valueS;
						day = "";
						break;
					default:
					case 'day':
						day = valueS;
						break;
				}

				var valueToReturn = '' + year + (month !== "" ? '-' + month + (day !== "" ? '-' + day : '') : '');
				onChange({ value: valueToReturn, type: 'birthdate' });
			};
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Birthdate, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    required = _props.required,
			    label = _props.label,
			    errorRequiredText = _props.errorRequiredText,
			    className = _props.className,
			    value = _props.value,
			    disabled = _props.disabled,
			    yearLabel = _props.yearLabel,
			    monthLabel = _props.monthLabel,
			    monthLabels = _props.monthLabels,
			    dayLabel = _props.dayLabel,
			    useNative = _props.useNative;
			var _state = this.state,
			    hasBeenFocused = _state.hasBeenFocused,
			    focus = _state.focus;


			var split = value.split('-');
			var year = split[0];
			var month = split.length > 1 ? split[1] : "";
			var day = split.length > 2 ? split[2] : "";

			var today = new Date();
			var todayYear = today.getFullYear();

			var numDays = year !== "" && month !== "" ? new Date(year, month, 0).getDate() : 0;

			var hasError = hasBeenFocused && required && value === "" && !focus;

			return _react2.default.createElement(
				'div',
				{ className: 'bnc_field bnc_field_birthdate ' + className },
				label && label !== '' && _react2.default.createElement(
					'span',
					{ className: (0, _classnames2.default)('label', {
							'is-error': hasError
						})
					},
					label,
					required && _react2.default.createElement(
						'abbr',
						null,
						'*'
					)
				),
				_react2.default.createElement(
					'div',
					{ className: 'bnc_field_birthdate_selects' },
					_react2.default.createElement(_Select2.default, {
						className: 'bnc_field_birthdate_select bnc_field_birthdate_select--year',
						onFocus: this.onFocus,
						onBlur: this.onBlur,
						value: year,
						dataset: Array(120).fill(null).map(function (v, i) {
							return {
								value: (todayYear - (i + 1)).toString(),
								label: (todayYear - (i + 1)).toString()
							};
						}),
						sort: false,
						defaultOptionLabel: yearLabel,
						onChange: this.onChange('year'),
						disabled: disabled,
						useNative: useNative
					}),
					_react2.default.createElement(_Select2.default, {
						className: 'bnc_field_birthdate_select bnc_field_birthdate_select--month',
						value: month,
						disabled: year === "" || disabled,
						dataset: monthLabels.map(function (v, i) {
							return {
								value: '' + (i + 1 < 10 ? '0' : '') + (i + 1),
								label: v
							};
						}),
						sort: false,
						defaultOptionLabel: monthLabel,
						onChange: this.onChange('month'),
						useNative: useNative
					}),
					_react2.default.createElement(_Select2.default, {
						className: 'bnc_field_birthdate_select bnc_field_birthdate_select--day',
						value: day,
						disabled: year === "" || month === "" || disabled,
						dataset: Array(numDays).fill(null).map(function (v, i) {
							return {
								value: '' + (i + 1 < 10 ? '0' : '') + (i + 1),
								label: '' + (i + 1 < 10 ? '0' : '') + (i + 1)
							};
						}),
						sort: false,
						defaultOptionLabel: dayLabel,
						onChange: this.onChange('day'),
						useNative: useNative
					})
				),
				hasError && _react2.default.createElement(
					'span',
					{ className: 'error' },
					errorRequiredText
				)
			);
		}
	}]);

	return Birthdate;
}(_react.PureComponent);

Birthdate.defaultProps = {
	required: false,
	disabled: false,
	label: '',
	errorRequiredText: 'This field is required',
	className: '',
	monthLabels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	dayLabel: 'Day',
	monthLabel: 'Month',
	yearLabel: 'Year',
	useNative: false
};

Birthdate.propTypes = {
	value: _propTypes2.default.string.isRequired,
	onChange: _propTypes2.default.func,
	monthLabels: _propTypes2.default.arrayOf(_propTypes2.default.string),
	label: _utils.StringOrReact,
	required: _propTypes2.default.bool,
	disabled: _propTypes2.default.bool,
	errorRequiredText: _utils.StringOrReact,
	className: _propTypes2.default.string,
	dayLabel: _utils.StringOrReact,
	monthLabel: _utils.StringOrReact,
	yearLabel: _utils.StringOrReact,
	useNative: _propTypes2.default.bool
};

exports.default = Birthdate;